import { render, staticRenderFns } from "./iconBackArrow.vue?vue&type=template&id=6eec9276&"
import script from "./iconBackArrow.vue?vue&type=script&lang=js&"
export * from "./iconBackArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports